import { render, staticRenderFns } from "./TeacherAvatarCard.vue?vue&type=template&id=78afbf0e"
import script from "./TeacherAvatarCard.vue?vue&type=script&lang=js"
export * from "./TeacherAvatarCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports